module.exports = __webpack_public_path__ + "static/media/Yes App Logo Final.ae40ab4f.svg";